import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import storage from '../../../utils/storage';

const AccessControl = (props) => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const token = storage.get('token');
        if (!token && location.pathname !== '/login') {
            navigate('/login', { replace: true });
        }
    }, [navigate, location]);

    return React.cloneElement(props.children);
};

export default AccessControl;